import './TimelineBarChart.scss';

import cn from 'classnames';
import { MdOutlineDelete } from 'react-icons/md';
import { TimelineEntry } from '@blisspointmedia/bpm-types/dist/OfflineInputs';
import { formatPercent } from '@blisspointmedia/bpm-types/dist/formatUtils';
import { Button } from '@Components/Button';
import { Size } from '@Components/designConstants';
import { dateToMddyy } from '../../../utils/date-utils';

interface TimelineAxisRowProps {
  index: number;
  timelineEntry: TimelineEntry;
  editingUnlocked?: boolean;
  pushStagedDelete?: (newDelete: TimelineEntry) => void;
}

export const TimelineAxisRow = ({
  index,
  timelineEntry,
  editingUnlocked,
  pushStagedDelete
}: TimelineAxisRowProps) => (
  <div className={cn('y-axis-tick', { 'background-grey': index % 2 === 0 })}>
    {editingUnlocked && pushStagedDelete && (
      <Button
        className='timeline-entry-delete'
        size={Size.SM}
        leadingElement={<MdOutlineDelete />}
        onClick={() => pushStagedDelete(timelineEntry)}
      />
    )}
    <div className='promo' title={timelineEntry.promoName}>
      <span>{timelineEntry.promoName}</span>
    </div>
    <div className='special-offer'>
      <span>{timelineEntry.specialOfferName}</span>
    </div>
    <div className='percentage-discount'>
      <span>
        {timelineEntry.percentageDiscount
          ? `${formatPercent(timelineEntry.percentageDiscount / 100, 0)} off`
          : ''}
      </span>
    </div>
    <div className='dates'>
      <span id='start-date'>{dateToMddyy(timelineEntry.startDate)}</span>
      <span id='date-separator'> –</span>
      <span id='end-date'>{dateToMddyy(timelineEntry.endDate)} </span>
    </div>
  </div>
);
